module.exports = __webpack_public_path__ + "img/tarjeta_sorteo_freidora_2024_fin_promocion.6a60ce17.jpg";